import React, { useRef } from 'react';

interface VideoPlayerProps {
    src: string;

}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src }) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    return (
        <div className="height-100 overflow-hidden" style={{ width: '100%', height: '100%' }}>
            <video
                ref={videoRef}
                controls
                style={{ width: '100%', height: '100%', objectFit: 'contain'}}
            >
                <source src={src} type="video/mp4" />
            </video>
        </div>
    );
};

export default VideoPlayer;